$(document).ready(function () {
   $(' .ingredients-alphabets,.ingredients-first, .ingredients-second').wrapAll('<div class="ingredients-sections-wrap">');

   // $(".ingredients-first, .ingredients-second").each(function(){
   //   var section = $(this).get();
   //   $(".ingredients-sections-wrap").append(section);
   // });
  
  // $(' .ingredients-first, .ingredients-second').wrapAll('<div class="ingredients-right-wrap">');
  var announcement_h = $('.shopify-section--announcement-bar').height();
  var header_h = $('.shopify-section--header').height();
  var offset_h = header_h + announcement_h;

  $('.ingredients-sections-wrap #ingredientList-alpha-new [data-letter]').each(function() {
    var start = $(this).attr('data-letter');
     var ing = $(".ingredients-sections-wrap .ingredientList--ingredient[id='"+start+"']")
		if (ing.length) {
		  var anchor = ing.attr('id');
		  var a = $('<a></a>');
		  a.attr('href', '#' + anchor).attr('data-offset', offset_h );
		  $(this).before(a);
		  a.append($(this));
		 $(".ingredients-sections-wrap #ingredientList-alpha-new a").on("click", function(){
          //  $('html, body').animate({
          //  scrollTop: ($("#"+anchor).offset().top - offset_h )
          // }, 2000);
        });
		}
  });
});